var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"banner"}),_c('router-view'),_c('bottom-tabbar',{attrs:{"tabbars":_vm.tabs},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }